import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import Tooltip from "Components/Common/Tooltip";

const EditButton = ({ t, ...props }) => (
  <IconButton sx={{ padding: "5px" }} {...props}>
    <Tooltip title={t("Change tariff")}>
      <EditIcon fontSize="small" />
    </Tooltip>
  </IconButton>
);

EditButton.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(EditButton);
